module.exports = __webpack_public_path__ + "static/media/multitier.3c0bd423.png";